export const PIN_LENGTH = 6
export const SEQUENCE = '0123456789'
export const INVERSE_SEQUENCE = '9876543210'
